import { observer } from "mobx-react-lite";

import { AmrapHeaderFields } from "src/components/AmrapHeaderFields";
import { BodyInstructionsField } from "src/components/BodyInstructionsField";

import {
  BaseDetailedWorkoutItemGroup,
  type WorkoutItemGroupProps,
} from "./BaseDetailedWorkoutItemGroup";

export const AmrapDetailedWorkoutItemGroup = observer(
  function AmrapDetailedWorkoutItemGroup(props: WorkoutItemGroupProps) {
    return (
      <BaseDetailedWorkoutItemGroup
        {...props}
        header={<AmrapHeaderFields workoutItemId={props.item.workoutItemId} />}
        body={
          <BodyInstructionsField workoutItemId={props.item.workoutItemId} />
        }
      />
    );
  },
);
